export const config = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL!,
}
